export default __webpack_public_path__ + "static/brand-asset-handoff-db8e91b8d8c4c0d3176f50f1838af29f.svg";